import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API_BASE_URL } from '../../api/api-clientInformation';
import { StartSessionResponse } from './session.models';

const CONTROLLER = '/api/OnePUserLoginSessions';

@Injectable({ providedIn: 'root' })
export class SessionAuditApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  startSession(): Observable<StartSessionResponse> {
    return this.http.post<StartSessionResponse>(
      `${this.baseUrl}${CONTROLLER}/StartUserLoginSession`,
      null
    );
  }

  heartbeat(sessionId: string): Observable<void> {
    return this.http.post<void>(this.sessionUrl('HeartbeatUserLoginSession', sessionId), null);
  }

  endSession(sessionId: string): Observable<void> {
    return this.http.post<void>(this.sessionUrl('EndUserLoginSession', sessionId), null);
  }

  /**
   * Swagger declares these routes without a separator before the id
   * (`EndUserLoginSession{sessionId}`). This is the single point of change if
   * the backend turns out to use `/`.
   */
  private sessionUrl(action: string, sessionId: string): string {
    return `${this.baseUrl}${CONTROLLER}/${action}${encodeURIComponent(sessionId)}`;
  }
}
